if (!customElements.get('stacks-with-module')) {
  class StacksWithModule extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._openModalId = null;

      window.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-modal-action="open"][data-modal-id]');
        if (opener?.dataset.modalId?.startsWith('stacks-qb-')) {
          this._openModalId = opener.dataset.modalId;
        }
      });

      window.addEventListener('submit', (e) => {
        if (!this._openModalId) return;
        if (!e.target.closest('[data-modal-content^="stacks-qb-"]')) return;
        window.dispatchEvent(new CustomEvent('modal:closeById', { detail: this._openModalId }));
        this._openModalId = null;
      });
    }
  }

  customElements.define('stacks-with-module', StacksWithModule);
}
